export const DEFAULT_BUTTON_STYLES =
  "flex items-center justify-center align-center rounded-md px-4 py-2.5 text-sm font-medium focus:outline-none focus:ring-1 focus:ring-stone-500";

export const SECONDARY_BUTTON_STYLES =
  "text-stone-900 dark:text-white bg-stone-200 dark:bg-stone-700 hover:bg-stone-100 dark:hover:bg-stone-600 transition-colors";
